export const selectPpeTestStatus = {
    bindings: {
        identifier: '@'
    },
    template: require('./select-ppe-test-status.html'),
    controller: 'SelectPpeTestStatusController'
};
